import React from 'react';
import {
  Button,
  Form,
  Header,
  Icon,
  Message,
  Dimmer,
  Loader,
  Image,
} from 'semantic-ui-react';
import FileUploadButton from '../fileUploadButton';

const PlanForm = ({ obj, status, onChange, onSubmit }) => {
  if (status.loading)
    return (
      <Dimmer active inverted>
        <Loader inverted>Chargement</Loader>
      </Dimmer>
    );
  return (
    <Form>
      <Header>Edition du plan</Header>
      {status.error ? (
        <Message negative>
          <Message.Header>Erreur</Message.Header>
          <p>{status.message}</p>
        </Message>
      ) : null}
      {!status.error && status.message ? (
        <Message info>
          <p>{status.message}</p>
        </Message>
      ) : null}
      <Form.Field>
        {typeof obj.image === 'string' ? (
          <Image src={obj.image} size="large" />
        ) : null}
        <FileUploadButton
          id="image"
          label="Image du plan"
          onChange={onChange}
        />
      </Form.Field>

      <Form.Field>
        <Form.Input
          label="URL Google Maps"
          type="string"
          placeholder="URL Google Maps"
          id="google_maps_url"
          value={obj.google_maps_url || ''}
          onChange={(e) => onChange(e)}
        />
      </Form.Field>

      <br />

      {status.loading ? (
        <Button type="submit" color="olive" loading></Button>
      ) : (
        <Button type="submit" color="olive" floated="left" onClick={onSubmit}>
          <Icon name="save" /> Sauvegarder
        </Button>
      )}
    </Form>
  );
};

export default PlanForm;



// WEBPACK FOOTER //
// ./src/components/form/Plan.js